import previewView from './previewView.js';
import View from './View.js';

class ResultsView extends View {
  _errorMessage = `No recipes in our database match your Search Query...`;

  _generateMarkup() {
    return this._data.map(result => previewView.render(result, false)).join('');
  }
}

export default new ResultsView('.results');
